module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Call_16"],"path":[{"$":{"d":"M10.49,11.48,12,10a.53.53,0,0,1,.75,0l2,2a.84.84,0,0,1-.18,1.3L13.1,14.45a2.93,2.93,0,0,1-2.57.41,13.72,13.72,0,0,1-5.63-3.75A13.72,13.72,0,0,1,1.15,5.47,2.93,2.93,0,0,1,1.55,2.9L2.68,1.42A.84.84,0,0,1,4,1.23l2,2A.53.53,0,0,1,6,4L4.52,5.51a.65.65,0,0,0,.09.83A17.21,17.21,0,0,0,6.84,9.16a17.21,17.21,0,0,0,2.82,2.23A.65.65,0,0,0,10.49,11.48Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Call_16.svg
// module id = dByM
// module chunks = 1